export const operators = [
  'is',
  'is not',
  'contains',
  'does not contain',
  'is empty',
  'is not empty',
] as const;

export const checkboxTypeValueOptions = [
  { label: 'true', value: 'true' },
  { label: 'false', value: 'false' },
];

export const checkboxTypeOperators = [
  'is',
  'is empty',
  'is not empty',
] as const;

export const numberTypeOperators = [
  'is',
  'is not',
  'is empty',
  'is not empty',
  'greater than',
  'less than',
] as const;

export const dateTypeOperators = [
  'between',
  'is empty',
  'is not empty',
] as const;

export const listTypeOperators = ['is', 'is not', 'is empty', 'is not empty'];

export const multiSelectListTypeOperators = [
  'contains one of',
  'does not contain one of',
];

export const multiOptionsTypeOperators = [
  'contains one of (exact)',
  'does not contain one of (exact)',
  'contains one of',
  'does not contain one of',
];

export const FILLED_CONDITION_ERR_MSG =
  'Condition with subsequent steps cannot be deleted';
